module.exports = __webpack_public_path__ + "static/tiefling-1-894626a643468b66b78cf236d8cfe2c3.png";